import React from 'react';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import grey from '@material-ui/core/colors/grey';

interface Props {}

const Loading = (props: Props) => {
  return (
    <>
      <Box position="absolute" width="100%">
        <LinearProgress />
      </Box>
      <Box height="100vh" bgcolor={grey[200]} />
    </>
  );
};

export default Loading;
